import gettext, { ngettext } from '@sdk/lang/gettext';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import { DismissButton } from '@sdk/components/ui/InfoModal/infoInnerModal.styles';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Spinner, { SpinnerSize } from '@sdk/components/ui/Spinner';

import { AnnouncementDashboardNotification } from '@web/announcements/types/AnnouncementDashboardNotification';
import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import { AnnouncementInnerContent } from '@web/announcements/AnnouncementInnerContent/AnnouncementInnerContent';

import { useAnnouncementNotification } from './announcementNotification.hooks';
import { ActionButtonsContainer, IconWrapper, Wrapper } from './announcementNotification.styles';

type Props = {
  onClose: () => void;
  notification: AnnouncementDashboardNotification;
};

export const AnnouncementNotification = ({ onClose, notification }: Props) => {
  const {
    announcement,
    dismissNotification,
    hasNext,
    hasPrev,
    isDismissing,
    itemsCount,
    nextAnnouncement,
    notificationIndex,
    prevAnnouncement,
  } = useAnnouncementNotification({ notification, onClose });

  let headerTitle = ngettext('Announcement', 'Announcements', itemsCount);
  if (itemsCount > 1) {
    headerTitle = `${headerTitle} (${notificationIndex + 1}/${itemsCount})`;
  }

  return (
    <Wrapper>
      <InfoModal
        buttonsPadding={0}
        fullScreen
        titleText={headerTitle}
        titleIcon={
          <IconWrapper>
            <ExclamationMarkIcon aria-hidden={true} />
          </IconWrapper>
        }
        zIndex={1045}
        dismiss={onClose}
        buttons={
          <ActionButtonsContainer>
            {itemsCount === 1 && (
              <DismissButton disabled={isDismissing} onClick={onClose}>
                {gettext('Leave for later')}
              </DismissButton>
            )}
            {hasPrev && (
              <DismissButton disabled={isDismissing} onClick={prevAnnouncement}>
                {gettext('Previous')}
              </DismissButton>
            )}
            {hasNext ? (
              <DismissButton
                disabled={isDismissing}
                buttonType={ButtonType.primary}
                onClick={nextAnnouncement}>
                {gettext('Next')}
              </DismissButton>
            ) : (
              <DismissButton
                disabled={isDismissing}
                buttonType={ButtonType.primary}
                onClick={dismissNotification}>
                {isDismissing ? <Spinner size={SpinnerSize.small} /> : gettext('Dismiss')}
              </DismissButton>
            )}
          </ActionButtonsContainer>
        }>
        <AnnouncementInnerContent announcement={announcement} disableManagement />
      </InfoModal>
    </Wrapper>
  );
};
